export enum AnalyticsSite {
  Main = 'main',
}

export enum AnalyticsFlow {
  Signup = 'signup',
}
